import React, { Suspense, useState, useEffect } from "react";
import styled from "styled-components";
import Header from "./Header";
import SideBar, { SIDEBAR_WIDTH, TOP_BAR_HEIGHT } from "./SideBar";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, Tooltip } from "@mui/material";
import { Triangle } from "react-loader-spinner";

// Move styled components outside the functional component
const StyledAppLayout = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.toggle ? SIDEBAR_WIDTH : 0)}px 1fr;
  grid-template-rows: auto 1fr;
  height: 100vh;
  transition: grid-template-columns 0.3s ease-in-out;
`;

const Main = styled.main`
  background-color: ${(props) =>
    props.mode === "dark" ? "#101418" : "#F3F5F7"};
  padding: ${TOP_BAR_HEIGHT + 16}px 1rem 2rem;
  overflow: auto;
  transition: background-color 0.3s ease-in-out;
`;

const StyleDiv = styled.div`
  background-color: #3d4f58;
  overflow: auto;
  grid-row: 1/-1;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  transition: all 0.3s;
  z-index: 3000;
  transition: opacity 0.3s ease-in-out;
`;

const IconButtonWrapper = styled.div`
  position: fixed;
  top: 14px;
  left: ${(props) => (props.toggle ? SIDEBAR_WIDTH + 10 : 10)}px;
  z-index: 20000;
  transition: left 0.3s ease-in-out;
`;

const PageLoading = () => (
  <div style={{ display: "flex", justifyContent: "center", padding: "80px 0" }}>
    <Triangle height="60" width="60" color="#4fa94d" ariaLabel="loading" />
  </div>
);

export default function AppLayout() {
  const mode = useSelector((state) => state.mode); // Use mode directly from Redux
  const [toggle, setToggle] = useState(true);

  useEffect(() => {
    // Any side effects related to mode can go here
  }, [mode]);

  return (
    <StyledAppLayout toggle={toggle}>
      <IconButtonWrapper toggle={toggle}>
        <Tooltip title={toggle ? "Hide menu" : "Show menu"}>
          <IconButton
            size="small"
            aria-label={toggle ? "Hide menu" : "Show menu"}
            onClick={() => setToggle(!toggle)}
            sx={{
              color: "rgba(255,255,255,0.85)",
              borderRadius: "6px",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
            }}
          >
            {toggle ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
        </Tooltip>
      </IconButtonWrapper>

      <Header sidebarOpen={toggle} />
      {toggle ? <SideBar /> : <StyleDiv></StyleDiv>}

      <Main mode={mode}>
        {/* Pages load when first opened (see App.js) */}
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </Main>
    </StyledAppLayout>
  );
}
